import React, { Fragment, useState , useEffect} from "react";
import { Col, Card, Form, Spinner} from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import Snackbars from "../../../utils/Snackbars";
import useRequests from "../../../utils/useRequests";
import DataTable from "react-data-table-component";


const EventsList = () => {
    const location = useLocation();
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const { getRequest } = useRequests();
    const [searchQuery, setSearchQuery] = useState('');


    const [AlertData, setAlertData] = React.useState({
            variant: '',
            message: '',
          });
        
          const resetAlertData = () => {
            setTimeout(() => {
              setAlertData((AlertData) => ({
                ...AlertData,
                variant: '',
                message: '',
              }));
            }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
          };

          const fetchEvents = async () => {
                    const response = await getRequest("event-list"); // Replace "users" with the appropriate API endpoint
                    // const response = resultData[0]
                    if (response && response.code === 200) {
                      setEvents(response.data.data);
                    } else {
                      console.error("Failed to fetch events:", response.message);
                      setAlertData((AlertData) => ({
                        ...AlertData,
                        variant: 'error',
                        message: 'Failed to fetch events',
                      }));
                    }
                    resetAlertData();
                    setLoading(false);
                  };
                
    useEffect(() => {
      fetchEvents();
      if (location.state && typeof location.state.message !== 'undefined') {
        setAlertData((AlertData) => ({
          ...AlertData,
          variant: location.state.status,
          message: location.state.message,
        }));
        resetAlertData();
        setLoading(false);
      }
    }, []);


     // Filter event  based on the search query
    const filteredEvent = events.filter((event) => {
        const city = `${event.city}`.toLowerCase();
        const name = `${event.name}`.toLowerCase();
        const status = `${event.status}`.toLowerCase();
        const searchLower = searchQuery.toLowerCase();
    
        return city.includes(searchLower) || status.includes(searchQuery) || name.includes(searchQuery);
    });





      const columns = [
              {
                name: "Event",
                selector: (row) => row.name,
                sortable: true,
                width:'300px'
                // whiteSpace:'normal !important'
              },
              {
                name: "City",
                selector: (row) => row.city,
                sortable: true,
                width:"300px"
              },
              
              {
                name: "Status",
                cell: (row) => (
                  <button
                    className={`btn ${
                      row.status === "Enable" ? "btn-success" : "btn-danger"
                    } btn-xxs`}
                  >
                    {row.status === "Enable" ? "Enable" : "Disable"}
                  </button>
                ),
                center: true,
                width: "300px",
              },
              {
                name: "Actions",
                cell: (row) => (
                  <div className="text-center">
                    <Link to={`/event-details/${row.e_id}`} className="btn btn-primary btn-xxs me-2" title="Event Details"> 
                        <i className="fa-regular fa-eye"></i> 
                    </Link>
                  </div>
                ),
                center: true,
                width: "200px",
              },
            ];
          
    
    const customStyles = {
    header: {
        style: {
          whiteSpace:"normal",
        // minHeight: "56px",
        // flexBasis:'auto !important',
        },
    },
    headCells: {
        style: {
        // flexBasis:'auto !important',
        color: "#341439",
        fontSize: "17px",
        fontWeight: "600",
        textTransform: "capitalize",
        paddingLeft: "8px", // Adjust padding
        paddingRight: "8px",
        },
    },
    cells: {
        style: {
        // flexBasis:'auto !important',
        fontSize: "16px",
        padding: "12px 9px",
        color: "#7E7E7E",
        
        },
    },
    pagination: {
        style: {
        fontSize: "16px",
        },
    },
    "& .hmVlQg div:first-child": {
    whiteSpace: "normal !important",
},
    };
    

    return (
        
      <Fragment>
        <div className='d-sm-flex d-block justify-content-between align-items-center mb-4'>
          <h2 className='text-black font-w600 mb-0'>Events</h2>
          {AlertData.message !== "" ? (
            <Snackbars
              variant={AlertData.variant}
              message={AlertData.message}
            />
          ) : (
            ""
          )}
        </div>

        {/* Search input */}
        <div className='mb-4 d-sm-flex d-block justify-content-end'>
          <div style={{position: "relative", width: "18rem"}}>
            <Form.Control
              type='text'
              placeholder='Search...'
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{
                width: "100%",
                fontSize: "18px",
                fontWeight: 500,
                paddingRight: "2rem",
                borderRadius: "0.625rem",
                height: "3.2rem", // Add padding to ensure the icon doesn't overlap text
              }}
            />
            <i
              className='fa fa-search'
              style={{
                position: "absolute",
                right: "10px", // Distance from the right edge of the input
                top: "50%",
                transform: "translateY(-50%)", // Center vertically
                color: "#6c757d", // Optional: color for the icon
                pointerEvents: "none", // Makes sure clicks pass through to the input
              }}
            ></i>
          </div>
        </div>
        <Col lg={12}> 
        <Card>
          <Card.Body>
            {loading ? (
              <div className='text-center'>
                <Spinner animation='border'variant="primary"  />
                <p>Loading settings...</p>
              </div>
            ) : (
              <DataTable
                columns={columns}
                data={filteredEvent} // Use filtered data
                customStyles={customStyles}
                pagination
                highlightOnHover
                responsive
              />
            )}
          </Card.Body>
        </Card>
        </Col>
      </Fragment>
    );
};

export default EventsList;
